import * as React from 'react';
import { classNames, Styleable } from '../utils/styles';

export const classes =
  'f5 link dim br-pill bg-near-white hover-bg-black-10 ph4 pv3 mh1 dib bw0 pointer black b';

export enum ButtonStyle {
  Danger = 'red',
  Confirm = 'black b',
  Normal = 'black-80',
}

export interface ButtonProps extends Styleable {
  onClick?: Function;
  children: any;
}

export const Button = (props: ButtonProps) => (
  <button
    type="button"
    className={classNames(classes, props.className)}
    onClick={() => props.onClick()}
  >
    {props.children}
  </button>
);
